module.exports = __webpack_public_path__ + "img/top.adc17320.jpg";